/** The two body layouts an announcement can be authored in. */
export type AnnouncementBodyStyle = 'plain' | 'bulleted'

// Body copy is authored in a textarea, so newlines are the real separator. The
// legacy `<br />` marker stays in the split because it is the only markup token
// that has ever appeared in promo copy (C-1708) and pasted copy still carries it.
const BODY_LINE_SEPARATOR = /\r?\n|<br\s*\/?>/i

/**
 * Splits an announcement `body` into plain-text lines. The single source of
 * truth for the split — consumers render the lines as React children
 * (auto-escaped), never as HTML, so backend `body` can't inject markup.
 *
 * `bulleted` drops blank lines: they would otherwise render as empty bullets.
 * `plain` keeps them, since a blank line there is a deliberate paragraph break.
 *
 * Lives in this lib rather than in either app because the admin preview and the
 * customer surfaces have to split identically — a preview that disagrees with
 * production is worse than no preview at all (C-1840).
 */
export function splitAnnouncementBody(body: string, bodyStyle: AnnouncementBodyStyle): string[] {
  const lines = body.split(BODY_LINE_SEPARATOR)

  if (bodyStyle === 'bulleted') {
    return lines.map((line) => line.trim()).filter((line) => line !== '')
  }

  return lines
}
